import { createTheme } from '@material-ui/core';

// declare module '@material-ui/core/styles/createTheme' {
//   interface Theme {
//     status: {
//       danger: React.CSSProperties['color'],
//     }
//   }
//   interface ThemeOptions {
//     status: {
//       danger: React.CSSProperties['color']
//     }
//   }
// }


declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    bgColor: Palette['primary'],
    textColor: PaletteOptions['secondary'];
  }
  interface PaletteOptions {
    bgColor: PaletteOptions['primary'],
    textColor: PaletteOptions['secondary'];
  }
}


export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },

  palette: {
    bgColor: { main: "#FFFFFF" },
    textColor: { main: "#000000" },
  },
});

export const darkTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },

  palette: {
    bgColor: { main: "#4A4848" },
    textColor: { main: "#FFFFFF" },
  },
});


